import { BaseService } from '../api';
import { SUBSCRIPTIONS_URL } from './constants';

export class SubscriptionService extends BaseService {
  updateSubscription = async (id, subscription) =>
    await this.client.patch(`${SUBSCRIPTIONS_URL}${id}/`, subscription);

  skipNextDelivery = async id =>
    await this.client.patch(
      `${SUBSCRIPTIONS_URL}${id}/skip_next_delivery/`,
      {},
    );

  reactivatePlan = async (id, couponCode) =>
    await this.client.put(
      `${SUBSCRIPTIONS_URL}${id}/activate/`,
      couponCode
        ? {
            coupon_code: couponCode,
          }
        : {},
    );
}
